import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  VIOLATIONS_REFRESH: createSagaAction('VIOLATIONS_REFRESH'),
  GET_VIOLATION_ATTACHMENTS: createSagaAction('GET_VIOLATION_ATTACHMENTS'),
  UPLOAD_VIOLATION_ATTACHMENT: createSagaAction('UPLOAD_VIOLATION_ATTACHMENT'),
  DELETE_VIOLATION_ATTACHMENT: createSagaAction('DELETE_VIOLATION_ATTACHMENT'),
  UPDATE_ATTACHMENT_DESCRIPTION: createSagaAction('UPDATE_ATTACHMENT_DESCRIPTION'),
  VIOLATION_CREATE: createSagaAction('VIOLATION_CREATE'),
  VIOLATION_UPDATE: createSagaAction('VIOLATION_UPDATE'),
  VIOLATION_DELETE: createSagaAction('VIOLATION_DELETE'),
  EDIT_VIOLATION_STATUS: createSagaAction('EDIT_VIOLATION_STATUS')
}

// Action Creators
export const actions = {
  violationsRefresh: ({ jobId }) => ({
    type: constants.VIOLATIONS_REFRESH.ACTION,
    jobId
  }),

  getViolationsAttachments: ({ violationId }) => ({
    type: constants.GET_VIOLATION_ATTACHMENTS.ACTION,
    violationId
  }),

  uploadAttachment: ({ formData, violationId }) => ({
    type: constants.UPLOAD_VIOLATION_ATTACHMENT.ACTION,
    formData,
    violationId
  }),

  deleteAttachment: ({ attachmentId, violationId }) => ({
    type: constants.DELETE_VIOLATION_ATTACHMENT.ACTION,
    attachmentId,
    violationId
  }),

  updateAttachmentDescription: ({ attachmentId, violationId, description, userId }) => ({
    type: constants.UPDATE_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    violationId,
    description,
    userId
  }),

  createViolation: ({ formData, jobId }) => ({
    type: constants.VIOLATION_CREATE.ACTION,
    formData,
    jobId
  }),

  updateViolation: ({ jobId, violationId, userId, content }) => ({
    type: constants.VIOLATION_UPDATE.ACTION,
    jobId,
    violationId,
    userId,
    content
  }),

  deleteViolation: ({ violationId, jobId }) => ({
    type: constants.VIOLATION_DELETE.ACTION,
    jobId,
    violationId
  }),

  setStatus: ({ content, violationId, jobId }) => ({
    type: constants.EDIT_VIOLATION_STATUS.ACTION,
    content,
    violationId,
    jobId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.VIOLATIONS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.VIOLATIONS_REFRESH.SUCCESS:
      return {
        ...state,
        violations: action.payload
      }

    case constants.GET_VIOLATION_ATTACHMENTS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_VIOLATION_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        jobViolationAttachments: action.payload
      }

    case constants.UPLOAD_VIOLATION_ATTACHMENT.ACTION:
      return { ...state, error: null, loading: true }
    case constants.UPLOAD_VIOLATION_ATTACHMENT.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_VIOLATION_ATTACHMENT.ACTION:
      return { ...state, error: null, loading: true }
    case constants.DELETE_VIOLATION_ATTACHMENT.SUCCESS:
      return {
        ...state
      }

    case constants.UPDATE_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.VIOLATIONS_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.VIOLATION_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.VIOLATION_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.VIOLATION_DELETE.SUCCESS:
      return {
        ...state
      }
    case constants.EDIT_VIOLATION_STATUS.ACTION:
      return { ...state, loading: true }
    case constants.EDIT_VIOLATION_STATUS.SUCCESS:
      return {
        ...state,
        loading: false,
        msg: 'Vehicle created!'
      }
    case constants.EDIT_VIOLATION_STATUS.FAILED:
      return {
        ...state,
        loading: false,
        msg: 'Problems creating vehicle, please try again.'
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/violationActions.js